/**
 * @file tipos.ts
 * @summary
 * Tipos para os componentes de cursor.
 */

import { HTMLAttributes, SVGProps } from "react";

/**
 * Chaves de cor do Tailwind para estilização de cursores.
 */
export type ColorKey =
  | "gray"
  | "red"
  | "orange"
  | "amber"
  | "green"
  | "emerald"
  | "teal"
  | "cyan"
  | "blue"
  | "indigo";

/**
 * Propriedades base para componentes HTML do cursor.
 */
export type CursorHTMLProps = HTMLAttributes<HTMLSpanElement>;

/**
 * Propriedades base para o componente SVG do cursor.
 */
export type CursorSVGProps = SVGProps<SVGSVGElement>;
